import styled from 'styled-components';

export default styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  background: rgba(39, 39, 39, 0.9);
  padding: 2.2rem 1.8rem 1.6rem 1.8rem;
  opacity: ${props => (props.visible ? '1' : '0')};
`;
